import { Component, OnInit } from '@angular/core';

import { SpinnerService } from '../../services/spinner.service';
import { AccountService } from '../../services/account.service';
import { TransferService } from '../../services/transfer.service';
import { StmtService } from '../../services/stmt.service';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {
    amount_multiplier: number = 1;
    new_transfer: any = {
        date: new Date().toISOString().slice(0, 10),
        amount: 0,
        name: '',
        comment: '',
        category: null,
        recurrent: null,
        done: false,
        account: null
    };
    _active: number = this.accountService.getCurrentAccount().id;
    get active() {
        return this._active;
    };
    set active(account: any) {
        this._active = account.id;
        this.accountService.setCurrentAccount(account);
        this.getTransfers();
        this.getOverview();
    };
    accounts: any[] = [];
    overview: any = {};
    transfers: any[] = [];

    constructor(private spinner: SpinnerService,
        private accountService: AccountService,
        private transferService: TransferService,
        private stmtService: StmtService) { }

    ngOnInit() {
        this.getAccounts();
        this.getTransfers();
        this.getOverview();
    }

    getAccounts() {
        this.spinner.startLoad('overview-getAccounts');
        this.accountService.getAccounts().subscribe(
            (accounts) => this.accounts = accounts,
            (err) => console.error(err),
            () => this.spinner.finishLoad('overview-getAccounts')
        );
    }

    getOverview() {
        this.spinner.startLoad('overview-getOverview');
        this.stmtService.getOverview().subscribe(
            (overview) => this.overview = overview,
            (err) => console.error(err),
            () => this.spinner.finishLoad('overview-getOverview')
        );
    }

    getTransfers() {
        const parameters = {
            limit: 10
        }
        this.spinner.startLoad('overview-getTransfer');
        this.transferService.getTransfers(parameters).subscribe(
            (transfers) => this.transfers = transfers,
            (err) => console.error(err),
            () => this.spinner.finishLoad('overview-getTransfer')
        );
    }

    createTransfer() {
        this.new_transfer.amount = this.new_transfer.amount * this.amount_multiplier;
        this.new_transfer.account = this.active;
        this.spinner.startLoad('overview-createTransfer');
        this.transferService.createTransfer(this.new_transfer).subscribe(
            (res) => this.postCreateTransfer(),
            (err) => console.error(err),
            () => this.spinner.finishLoad('overview-createTransfer')
        );
    }

    postCreateTransfer() {
        this.getTransfers();
        this.new_transfer = {
            date: new Date().toISOString().slice(0, 10),
            amount: 0,
            name: '',
            comment: '',
            category: null,
            recurrent: null,
            done: false,
            account: null
        };
    }
}
